/* eslint-disable react-hooks/exhaustive-deps */
import { useAppInsights } from '@davies-group/error-handling';
import * as React from 'react';
import axios, { AxiosResponse } from 'axios';

import { applicationSettings } from '../utils';

const useUploadService = () => {
    const appInsights = useAppInsights();

    const checkResponse = <T>(url: string, response: AxiosResponse<T>): boolean => {
        if (response.status >= 200 && response.status <= 299) {
            appInsights.info(`Call to ${url} was successful`);
            return true;
        }

        throw new Error(`Failed to call ${url} (Status: ${response.status})`);
    };

    const uploadDocument = React.useCallback((requestId: string, documentId: string, uploadedDocumentId: string, uploadedDocumentName: string) => {
        const url = `${applicationSettings.documentRequestApiUrl}/v1.0/upload/${requestId}/${documentId}`;

        return axios
            .post(url, { id: uploadedDocumentId, name: uploadedDocumentName })
            .then((response) => {
                checkResponse(url, response);
                return true;
            })
            .catch((err) => {
                appInsights.error(`Failed to call ${url} (Status: ${err})`, err);
                throw new Error(`Failed to call ${url} (Status: ${err})`);
            });
    }, []);

    const deleteDocument = React.useCallback((requestId: string, documentId: string, uploadedDocumentId: string) => {
        const url = `${applicationSettings.documentRequestApiUrl}/v1.0/upload/${requestId}/${documentId}/${uploadedDocumentId}`;

        return axios
            .delete(url)
            .then((response) => {
                checkResponse(url, response);
                return true;
            })
            .catch((err) => {
                appInsights.error(`Failed to call ${url} (Status: ${err})`, err);
                throw new Error(`Failed to call ${url} (Status: ${err})`);
            });
    }, []);

    return { uploadDocument, deleteDocument } as const;
};

export default useUploadService;
